export enum 商品区分型 {
    医薬品 = '医薬品',
    その他品 = 'その他品',
}

export enum 在庫区分型 {
    通常 = '通常',
    譲受 = '譲受',
}

export enum 選択状態区分型 {
    対象 = '対象',
    対象外 = '対象外',
}

export enum 検索対象商品区分型 {
    医薬品 = '医薬品',
    その他品 = 'その他品',
}

export enum 検索対象ソート区分型 {
    商品名 = '商品名',
    規格容量 = '規格容量',
    メーカー名 = 'メーカー名',
}

